import type { ReactNode } from 'react'

import type { PermissionKey } from '@/lib/permissions'
import { usePermissions } from '@/lib/use-permissions'

import { NoAccess } from './no-access'
import { LoadingNotice } from './loading-notice'

export function PermissionGate({
  permission,
  children,
}: {
  permission: PermissionKey
  children: ReactNode
}) {
  const { can, ready } = usePermissions()

  if (!ready) {
    return <LoadingNotice message="Loading permissions…" />
  }
  if (!can(permission)) return <NoAccess />
  return <>{children}</>
}
